import { useEffect, useState } from 'react';
import { useField } from '../../../hooks/use-field';
import { usePageImage } from './use-page-image';
export const useImage = (mediaId) => {
    const staticImage = usePageImage(mediaId);
    const field = useField('media_nodes', 'IMA:MEDIA_NODES', {
        isPageField: true
    });
    const [image, setImage] = useState(staticImage);
    useEffect(() => {
        const mediaNode = field.value?.[mediaId];
        if (mediaNode) {
            setImage({
                image: {
                    placeholder: {
                        fallback: mediaNode.preview?.url
                    },
                    layout: 'constrained',
                    images: {
                        fallback: {
                            src: mediaNode.url
                        }
                    },
                    width: mediaNode.width,
                    height: mediaNode.height
                },
                description: mediaNode.description || ''
            });
        }
        else {
            setImage(staticImage);
        }
        if (!mediaId) {
            setImage(undefined);
        }
    }, [field.value, mediaId]);
    return image;
};
